const searchToObject = (searchStr) => {
  const result = {};
  new URLSearchParams(searchStr).forEach(
    (value, key) => (result[key] = JSON.parse(decodeURIComponent(value)))
  );
  return result;
};

const objectToSearch = (searchObj, filterEmpty) => {
  const rawStr = Object.keys(searchObj)
    .reduce((acc, key) => {
      const value = searchObj[key];
      const shouldNotPush =
        (filterEmpty && Array.isArray(value) && value?.length === 0) ||
        (!Array.isArray(value) &&
          typeof value === 'object' &&
          Object.keys(value).length === 0) ||
        !value;
      if (!shouldNotPush) {
        acc.set(key, encodeURIComponent(JSON.stringify(searchObj[key])));
      }
      return acc;
    }, new URLSearchParams())
    .toString();

  return rawStr ? `?${rawStr}` : '';
};

export { searchToObject, objectToSearch };
